/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useCallback, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { NumberParam, useQueryParams, withDefault } from "use-query-params";

import { List } from "antd";

import { Page } from "../../components/page";
import { alertsFetchRequest } from "../../store/alerts/actions";
import { RootState } from "../../store/root_reducer";

import styles from "./styles.module.scss";

export const AlertsPage: React.FC = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("alerts_page");
  const reportState = useSelector((state: RootState) => state.Alerts);

  const [pagination, setPagination] = useQueryParams({
    page: withDefault(NumberParam, 1),
    pageSize: withDefault(NumberParam, 10),
  });

  const fetch = useCallback(() => {
    dispatch(alertsFetchRequest(pagination));
  }, [dispatch, pagination, i18n.language]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <Page title={t("page.title")} description={t("page.description")}>
      <List
        size="large"
        loading={reportState.isLoading}
        dataSource={reportState.alerts}
        renderItem={(item) => (
          <List.Item key={item.id}>
            <List.Item.Meta
              title={
                <>
                  <div>{item.title}</div>
                  <div className={styles.date}>{item.createdAt}</div>
                </>
              }
              description={<div className={styles.description}>{item.description}</div>}
            />
          </List.Item>
        )}
        pagination={{
          total: reportState.count,
          current: pagination.page,
          pageSize: pagination.pageSize,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "100"],
          onChange: (page, pageSize) => {
            if (page && pageSize) {
              setPagination((currentPagination) => ({
                ...currentPagination,
                pageSize,
                page: pageSize !== currentPagination.pageSize ? 1 : page,
              }));
            }
          },
        }}
        rowKey={(item) => `${item.id}`}
      />
    </Page>
  );
};
